import { render, staticRenderFns } from "./DadosVaga.vue?vue&type=template&id=3fe0eb68"
import script from "./DadosVaga.vue?vue&type=script&lang=js"
export * from "./DadosVaga.vue?vue&type=script&lang=js"
import style0 from "./DadosVaga.vue?vue&type=style&index=0&id=3fe0eb68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports